<template>
  <section class="register">
    <div class="box" style="max-width: 70%; padding-bottom: 25px">
      <div class="header">
        <div class="title">Detalhes</div>
        <div @click="close" class="close"><i class="fas fa-times"></i></div>
      </div>
      <form @submit.prevent class="form">
        <label v-if="log.level === 'info'" class="log-title info">
          <i class="fas fa-info"></i>
          <span>info</span>
        </label>
        <label v-else-if="log.level === 'warn'" class="log-title warn">
          <i class="fas fa-exclamation"></i>
          <span>warning</span>
        </label>
        <label v-else class="log-title error">
          <i class="fas fa-times"></i>
          <span>error</span>
        </label>
        <label class="log-label">Data</label>
        <div class="log-value">{{ log.dateFmt }}</div>
        <label class="log-label">Módulo</label>
        <div class="log-value">{{ log.from }}</div>
        <label class="log-label">Mensagem</label>
        <div class="log-value">{{ log.message }}</div>
        <label v-if="log.stack" class="log-label">Stack</label>
        <div v-if="log.stack" class="log-value">{{ log.stack }}</div>
        <label v-if="log.version" class="log-label">Versão</label>
        <div v-if="log.version" class="log-value">{{ log.version }}</div>
        <label v-if="log.user" class="log-label">Usuário</label>
        <div v-if="log.user" class="log-value">{{ log.user }}</div>
        <label v-if="log.userAgent" class="log-label">Navegador</label>
        <div v-if="log.userAgent" class="log-value">{{ log.userAgent }}</div>

      </form>
    </div>
  </section>
</template>

<script>
export default {
  props: ['log', 'close']
}
</script>

<style lang="scss" scoped>
@import "../_asset/scss/_variables";

.log-title {
  font-size: 1.1em;
  font-weight: 500;
  span {
    margin-left: 5px;
  }
  &.info { color: rgb(8, 8, 134) }
  &.warn { color: rgb(161, 161, 7) }
  &.error { color: rgb(128, 16, 16) }
}

.log-label {
  color: $primary-color;
  font-weight: 500;
}

.log-value {
  margin-top: 3px;
  color: #777;
  max-height: 100px;
  overflow-y: auto;
}
</style>
